import { XStylesSettings } from '@shared/types/types';
import { ButtonProps } from '../model/types';
import * as stylex from '@stylexjs/stylex';
import { styles } from './styles';

const Button = (props: ButtonProps) => {
  const {
    size = 'medium',
    isDisabled = false,
    isActive = false,
    variant = 'primary',
    children,
    onClick,
    settings,
  } = props;
  return (
    <button
      role="button"
      {...stylex.props([
        styles.base,
        styles[size],
        styles[variant],
        isActive && styles.active,
        settings as XStylesSettings,
      ])}
      disabled={isDisabled}
      onClick={onClick}
    >
      {children}
      {!isDisabled && <div {...stylex.props([styles.before])} />}
    </button>
  );
};

export default Button;
